import { all, call, fork, put, select, takeEvery } from 'redux-saga/effects';
import { SagaIterator } from '@redux-saga/core';
import { CategoryApisActionTypes } from './constants';
import { categoryApiResponseSuccess, categoryApiResponseError } from './actions';

import { APICore } from '../../helpers/api/apiCore';
// import { fetchCategorySuccess, fetchCategoryFailure } from './actions';
import { RootState } from '../store';
// import { FreeApisActionTypes } from '../freeApis/constants';

const api = new APICore();

function* categoryApis(): SagaIterator {
    try {
        const response = yield call(() => api.get(`/category`, {}));
        const data = response && response.data;
        yield put(categoryApiResponseSuccess(CategoryApisActionTypes.GET_CATEGORIES_APIS_DATA, data));
    } catch (error: any) {
        console.log(error, 'error---');
        yield put(categoryApiResponseError(CategoryApisActionTypes.GET_CATEGORIES_APIS_DATA, 'Something Went Wrong'));
    }
}

export function* watchCategoryApis() {
    yield takeEvery(CategoryApisActionTypes.GET_CATEGORIES_APIS_DATA, categoryApis);
}

function* categoryApisSaga() {
    yield all([fork(watchCategoryApis)]);
}

export default categoryApisSaga;
